export default __webpack_public_path__ + "static/media/Skirmisher's War Glaive.c31fd59f.jpg";